<template>
  <div class="table-container w-full">
    <div class="flex overflow-x-auto">
      <table v-for="i in tableCnt"
             :key="i"
             style="width: auto;"
             :class="[
               'max-w-none border-2 border-gray-600 bg-white table-fixed',
               tableCnt === 1 ? 'mx-auto' : i === 1 ? 'ml-auto' : i === tableCnt ? 'mr-auto ml-2' : 'ml-2'
             ]"
      >
        <thead class="border border-gray-600 bg-gray-200">
          <tr class="border border-gray-600">
            <th>{{ $t('testBank.sheet.number') }}</th>
            <th>{{ $t('testBank.answer') }}</th>
            <th>{{ $t('testBank.sheet.point') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="j in questionCntPerTable(i)"
              :key="j"
              class="h-8 border border-gray-600 transition"
              :class="[
                { 'cursor-pointer hover:bg-gray-100': !disabled },
              ]"
              @click.prevent="onMoveQuestion(questionNum(i, j))"
          >
            <td>{{ questionNum(i, j) }}</td>
            <td :class="[question(i, j)?.questionType === 'CHOICE' ? 'py-1' : 'py-3']">
              <div class="flex justify-center items-center gap-x-1 break-all">
                <div v-for="(answer, k) in question(i, j)?.answerList"
                     :key="answer.answerId"
                     :class="{ 'hidden': question(i, j)?.questionType === 'CHOICE' && !answer.correct }"
                >
                  <div :class="[
                         question(i, j)?.questionType === 'CHOICE'
                           ? 'w-5 h-5 border border-gray-800 rounded-full flex justify-center items-center'
                           : 'max-w-sm text-left whitespace-pre-line'
                       ]"
                  >{{ question(i, j)?.questionType === 'CHOICE' ? k + 1 : answer.answerText }}</div>
                </div>
              </div>
            </td>
            <td>{{ question(i, j).questionScore }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestbankResultCorrectTable',
  props: {
    disabled: { type: Boolean, default: false },
    questionList: { type: Array, default: () => [] }
  },
  computed: {
    tableCnt() {
      return Math.ceil(this.questionList?.length / 10) || 0;
    },
    question() {
      return (i, j) => this.questionList[(i - 1) * 10 + j - 1];
    },
    questionNum() {
      return (i, j) => (i - 1) * 10 + j;
    },
    questionCntPerTable() {
      return i => this.questionList?.length - (i - 1) * 10 < 10 ? this.questionList?.length - (i - 1) * 10 : 10;
    }
  },
  methods: {
    onMoveQuestion(questionNum) {
      if (this.disabled) {
        return;
      }

      document.querySelector(`#question_${questionNum}`).scrollIntoView();
    }
  }
}
</script>

<style lang="postcss" scoped>
caption {
    font-size:0;
    text-indent:-9999px;
}
th, td {
  @apply border-r border-gray-600 py-1 px-3 text-xs text-center whitespace-nowrap;
}

</style>